import { view } from '@risingstack/react-easy-state';

export default view(()=> {
    return (
        <>
            <h2> 404 </h2>
        </>
    )
})